import { initSelect2Modal, hideModalOn } from './select2_modal'

initSelect2Modal({
  modalId: 'invite-participant-modal',
  selectId: 'user_id',
  placeholder: 'Search colleagues by name or email…',
})

hideModalOn('closeInviteModal', '#invite-participant-modal.show')
